import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import {
  Heading,
  PageSubTitle,
  Text
} from 'components/common/Elements/Elements';
import ProgressBarLikelty from '../ProgressBarLikelty/ProgressBarLikelty';

import classes from './AdditionalContent.module.scss';

const AdditionalContent = ({ data }) => {
  const { t } = useTranslation(['activity']);

  return (
    <>
      <PageSubTitle
        title={t('activity:cancellation.ADDITIONAL_DATA')}
        className={classes.title}
        size={2}
      />
      <div className={classes.children}>
        <div className={classes.labelInfoWrap}>
          <Heading>{t('activity:cancellation.MISSING_FEATURES')}</Heading>
          <Text type={'p'} className={classes.infoText}>
            {data.missingFeatures}
          </Text>
        </div>
        <div className={classes.labelInfoWrap}>
          <Heading>
            {t('activity:cancellation.EXPENSIVE_REASON_COMMENT')}
          </Heading>
          <Text type={'p'} className={classes.infoText}>
            {data.expensiveReasonComment}
          </Text>
        </div>
        <div className={classes.labelInfoWrap}>
          <Heading>
            {t('activity:cancellation.HOW_LIKELY_ARE_YOU_TO_RETURN')}
          </Heading>
          <ProgressBarLikelty likely={data.likelyToReturn} />
        </div>
        <div className={classes.labelInfoWrap}>
          <Heading>{t('activity:cancellation.FEEDBACK')}</Heading>
          <Text type={'p'} className={classes.infoText}>
            {data.feedback}
          </Text>
        </div>
      </div>
    </>
  );
};

AdditionalContent.propTypes = {
  data: PropTypes.shape({
    feedback: PropTypes.string,
    missingFeatures: PropTypes.string,
    expensiveReasonComment: PropTypes.string,
    likelyToReturn: PropTypes.number
  })
};

export default AdditionalContent;
